import React from 'react';

import { SelectableList } from './SelectableList';

interface ManageRoutesProps {
  mode: 'view' | 'edit';
  routes: string[];
  onRoutesChange?: (routes: string[]) => void;
  availableRoutes?: string[];
}

export function ManageRoutes({
  mode,
  routes,
  onRoutesChange,
  availableRoutes = [],
}: ManageRoutesProps) {
  return (
    <SelectableList
      mode={mode}
      title="Routes"
      selectedItems={routes}
      availableItems={availableRoutes}
      onSelectionChange={onRoutesChange}
      caption={`Alert has been linked to ${routes.length} route${routes.length === 1 ? '' : 's'}`}
      emptyStateMessage="No routes found"
      searchPlaceholder="Search"
    />
  );
}
